exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".initiativetypespage-cssmodule-initiativetypespage-component-2Z89P{border:1px dashed red;padding-top:10px;border:none}", ""]);

// exports
exports.locals = {
	"initiativetypespage-component": "initiativetypespage-cssmodule-initiativetypespage-component-2Z89P"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/InitiativeTypes/initiativetypespage.cssmodule.scss
// module id = 604
// module chunks = 0